import axios from 'axios';
import { getSessionToken } from '@shopify/app-bridge/utilities';
import { BASE_URL, API__PREFIX, API__VERSION } from 'utils/configs';

let appBridgeInstance = null;

export function refreshAxiosInstance() {
  axios.defaults.baseURL = `${BASE_URL}${API__PREFIX}${API__VERSION}`;
  axios.defaults.withCredentials = true;
}

/**
 * Sets up the App Bridge instance for axios
 * Call this once when initializing the application
 */
export const setAppBridgeInstance = app => {
  if (appBridgeInstance && app !== appBridgeInstance) {
    console.warn('⚠️ App Bridge instance already exists, replacing...');
  }
  appBridgeInstance = app;
  console.log('✅ App Bridge instance set for axios');
};

export const getAppBridgeInstance = () => {
  return appBridgeInstance;
};

//** Create axios instance */
const axiosInstance = axios.create({
  baseURL: `${BASE_URL}${API__PREFIX}${API__VERSION}`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

//** Request interceptor - adds a Session Token to every request from axiosInstance */
axiosInstance.interceptors.request.use(
  async config => {
    console.log('use interceptor');
    const appBridgeInst = getAppBridgeInstance();

    if (appBridgeInst) {
      try {
        const token = await getSessionToken(appBridgeInst);

        config.headers.Authorization = `Bearer ${token}`;
        config.headers['X-Shopify-Authorization'] = `Bearer ${token}`;

        console.log('Session token added');
      } catch (error) {
        console.error('Failed to get session token:', error);
      }
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//** Response interceptor - error handling */
axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    //** If it is not a retry request. We only process 401 errors */
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const appBridgeInst = getAppBridgeInstance();
      if (appBridgeInst) {
        try {
          const token = await getSessionToken(appBridgeInst);

          // Update the token in the original request
          originalRequest.headers.Authorization = `Bearer ${token}`;
          originalRequest.headers[
            'X-Shopify-Authorization'
          ] = `Bearer ${token}`;

          // Repeat request
          return axiosInstance(originalRequest);
        } catch (err) {
          console.error('Token refresh failed:', err);
          return Promise.reject(err);
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
